import { render, staticRenderFns } from "./СMCourseCounts.vue?vue&type=template&id=28cbbf7c&scoped=true&lang=pug"
import script from "./СMCourseCounts.vue?vue&type=script&lang=js"
export * from "./СMCourseCounts.vue?vue&type=script&lang=js"
import style0 from "./СMCourseCounts.vue?vue&type=style&index=0&id=28cbbf7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cbbf7c",
  null
  
)

export default component.exports